import React, { useState } from 'react'
import { Form, Tab, Tabs } from 'react-bootstrap'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import Editor from 'react-ckeditor5-custom'
import i18n from '../../translation/i18n'
import styled from 'styled-components'

import LanguageIcon from '../../assets/icons/ICN_BTN_Translate.svg'
import { StyledValidationMessage } from '../Employees/Form/formHelper'

const HtmlEditorWrapper = styled.div`
  min-height: 200px;
  max-height: 400px;
  overflow-y: auto;
  width: 100%;
`

const MultiLangEditorInput = ({
  openLanguageModal,
  languageArray,
  onChange,
  label,
  isInvalid,
  disabled = false,
  mode = 'richText', // 'richText' | 'html' | 'textarea' | 'text'
}) => {
  const selectedLanguage = i18n.language.toUpperCase()
  const [activeTab, setActiveTab] = useState(mode)

  const value =
    languageArray.find((obj) => obj.langIsoCode === selectedLanguage)?.value ||
    ''

  const updateTranslationValue = (lang, newValue) => {
    const updated = [...languageArray]
    const index = updated.findIndex((obj) => obj.langIsoCode === lang)
    if (index >= 0) {
      updated[index].value = newValue
    } else {
      updated.push({ langIsoCode: lang, value: newValue })
    }
    onChange(updated)
  }

  const handleChange = (val) => {
    updateTranslationValue(selectedLanguage, val)
  }

  const isInvalidState = !!isInvalid

  return (
    <Form.Group className='mb-3'>
      <Form.Label>{label}</Form.Label>
      <div className='d-flex justify-content-between align-items-center mb-2'>
        <div className='flex-grow-1 me-3'>
          <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            mountOnEnter
            unmountOnExit
            className='mb-0'
          >
            <Tab eventKey='richText' title='Editor' />
            <Tab eventKey='html' title='HTML' />
          </Tabs>
        </div>
        <img
          src={LanguageIcon}
          alt='translate'
          style={{
            cursor: disabled ? 'not-allowed' : 'pointer',
            height: '28px',
            marginTop: '2px',
          }}
          onClick={!disabled ? openLanguageModal : null}
        />
      </div>

      <div className='mt-3'>
        {activeTab === 'richText' ? (
          <CKEditor
            editor={Editor}
            data={value}
            config={{
              toolbar: [
                'undo',
                'redo',
                '|',
                'fontSize',
                'fontColor',
                'fontBackgroundColor',
                '|',
                'bold',
                'italic',
                'underline',
                'strikethrough',
                '|',
                'link',
                'insertTable',
                'blockQuote',
                '|',
                'bulletedList',
                'numberedList',
                'outdent',
                'indent',
              ],
            }}
            onChange={(event, editor) => handleChange(editor.getData())}
          />
        ) : (
          <HtmlEditorWrapper>
            <Form.Control
              as='textarea'
              value={value}
              onChange={(e) => handleChange(e.target.value)}
              disabled={disabled}
              placeholder={label}
              isInvalid={isInvalid}
              style={{ minHeight: '200px' }}
            />
          </HtmlEditorWrapper>
        )}
      </div>

      {isInvalidState && (
        <StyledValidationMessage>{isInvalid}</StyledValidationMessage>
      )}
    </Form.Group>
  )
}

export default MultiLangEditorInput
